import { CustomizeStandingPage } from "./CustomizeStandingPage";

export default CustomizeStandingPage;